import { useEffect, useState } from "react";
import { loadRuntime, type Runtime } from "../components/common/runtime";

export function useRuntime() {
  const [runtime, setRuntime] = useState<Runtime | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    loadRuntime()
      .then(value => { if (active) setRuntime(value); })
      .catch(() => { if (active) setError("Impossible de charger le rapport."); });
    return () => { active = false; };
  }, []);

  return { runtime, error };
}
